const baseProductionCdnUrl =
  'https://az742526.vo.msecnd.net/files/odsp-next-release-odc_2018-04-13_20180418.001/odsp-media/images/apps/';
const fabricAssetsCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';

export const ChicletTestImages = {
  iconWordDoc: baseProductionCdnUrl + 'word_16x1.svg',
};

export const PersonaTestImages = {
  personFemale: `${fabricAssetsCdnUrl}/persona-female.png`,
  personMale: `${fabricAssetsCdnUrl}/persona-male.png`,
};
